import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './cubique-support.component.html',
  styleUrls: ['./cubique-support.component.scss']
})
export class CubiqueSupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
